import Select from "react-select";
import CustomButton from "../buttons/CustomButton";
import { reactSelectStyles } from "../../assets/js/react-select-styles";
import { formatFilterDate } from "@utils/general/format-filter-date";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { useGetAllContractCustomersQuery } from "@states/customer/customer.api";
import { useGetAllBusinessUnitsQuery } from "@states/customer/business-unit.api";

const ConsignmentReportFilter = (props: {
  filterRef: React.MutableRefObject<{
    from_date: undefined;
    to_date: undefined;
    customer_id: undefined;
    business_unit_id: undefined;
  }>;
  refetch: () => void;
}) => {
  const { filterRef, refetch } = props;
  const [curFromDate, setCurFromDate] = useState<Date | null>(null);
  const [curToDate, setCurToDate] = useState<Date | null>(null);
  const today = new Date();
  const lastMonth = new Date();
  lastMonth.setMonth(today.getMonth() - 1);

  useEffect(() => {
    setCurFromDate(lastMonth);
    setCurToDate(today);
  }, []);

  const { data: contractCustomerData } = useGetAllContractCustomersQuery({
    limit: 1000,
  });
  const { data: businessUnitData } = useGetAllBusinessUnitsQuery({
    page: 1,
    limit: 1000,
  });

  //@ts-ignore
  const formattedCustomers = contractCustomerData?.data?.map((cc: any) => ({
    label: cc.customer_first_name || cc.customer_last_name,
    value: cc.customer_id,
  }));

  // @ts-ignore
  const formattedBusinessUnits = businessUnitData?.data?.map((cc: any) => ({
    label: cc.business_unit_name,
    value: cc.business_unit_id,
  }));

  const onChangeHandler = (val: any, key: string) => {
    if (key === "from_date" || key === "to_date") {
      filterRef.current = {
        ...filterRef.current,
        [key]: formatFilterDate(val),
      };
      return;
    }

    const { value } = val;
    filterRef.current = {
      ...filterRef.current,
      [key]: value,
    };
  };

  return (
    <div className="flex items-end mb-5 flex-wrap gap-y-3">
      <div className="mr-6 basis-[18%] flex flex-col">
        <label className="text-gray-700" htmlFor="from_date">
          From Date
        </label>
        <div className="relative block text-gray-400 cursor-pointer focus-within:text-gray-600">
          <DatePicker
            selected={curFromDate}
            wrapperClassName="w-full"
            className="ring-primary px-3 mt-[0.5rem] border-primary-light border-[0.5px] h-[34px] w-full block rounded"
            dateFormat={"dd MMM yyyy"}
            onChange={(val) => {
              setCurFromDate(val);
              onChangeHandler(val, "from_date");
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="currentColor"
            className={`absolute w-6 h-6 transform -translate-y-1/3 cursor-pointer top-1/2 right-3`}
          >
            <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
          </svg>
        </div>
      </div>
      <div className="mr-6 basis-[18%] flex flex-col">
        <label className="text-gray-700" htmlFor="to_date">
          To Date
        </label>
        <div className="relative block text-gray-400 cursor-pointer focus-within:text-gray-600">
          <DatePicker
            selected={curToDate}
            wrapperClassName="w-full"
            className="ring-primary px-3 mt-[0.5rem] border-primary-light border-[0.5px] h-[34px] w-full block rounded"
            dateFormat={"dd MMM yyyy"}
            onChange={(val) => {
              setCurToDate(val);
              onChangeHandler(val, "to_date");
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="currentColor"
            className={`absolute w-6 h-6 transform -translate-y-1/3 cursor-pointer top-1/2 right-3`}
          >
            <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
          </svg>
        </div>
      </div>
      <div className="mr-6 basis-[18%]">
        <label className="mb-2 text-gray-700" htmlFor="customer">
          Customer Name
        </label>
        <Select
          styles={reactSelectStyles}
          placeholder="All"
          options={
            formattedCustomers && [
              { label: "All", value: undefined },
              ...formattedCustomers,
            ]
          }
          onChange={(val) => onChangeHandler(val, "customer_id")}
        />
      </div>
      <div className="mr-6 basis-[18%]">
        <label className="mb-2 text-gray-700" htmlFor="business_unit">
          Business Unit
        </label>
        <Select
          styles={reactSelectStyles}
          placeholder="All"
          options={
            formattedBusinessUnits && [
              { label: "All", value: undefined },
              ...formattedBusinessUnits,
            ]
          }
          onChange={(val) => onChangeHandler(val, "business_unit_id")}
        />
      </div>
      <div className="basis-1/6">
        <CustomButton
          handleClick={() => refetch()}
          className="w-24 h-[2.4rem]"
          title="Filter"
        />
      </div>
    </div>
  );
};

export default ConsignmentReportFilter;
